import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { formLegacyDefaultDataSchema } from './data';

/**
 * Default-placement legacy form envelope.
 *
 * `type` is `z.literal('default').optional()` so that:
 *  - persisted entities written before the discriminator existed (which omit
 *    `type` entirely) still parse here, and
 *  - the zod discriminated union in `./entity.ts` can dispatch on `type` —
 *    `.optional()` is allowed inside `z.discriminatedUnion` and falls through
 *    to this branch when the field is missing.
 *
 * Mirrors the button widget's envelope pattern (`button/schemas/legacy/default.ts`).
 */
export const formLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('form'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('default').optional(),
    data: formLegacyDefaultDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
